"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n = exports.defaultLongDateFormat = void 0;
exports.expandFormat = expandFormat;
exports.daysInYear = daysInYear;
exports.weeksInYear = weeksInYear;
exports.weekOfYear = weekOfYear;
exports.dateFormat = dateFormat;
const formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
const localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
exports.defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A',
    l: 'M/D/YYYY',
    ll: 'MMM D, YYYY',
    lll: 'MMM D, YYYY h:mm A',
    llll: 'ddd, MMM D, YYYY h:mm A'
};
exports.i18n = {
    dayNames: [
        'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa',
        'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
        'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
    ],
    monthNames: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
        'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ]
};
function expandFormat(format) {
    let i = 5;
    function replaceLongDateFormatTokens(input) {
        return exports.defaultLongDateFormat[input] || input;
    }
    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }
    return format;
}
function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}
function getDayOfYear(date) {
    const dayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
    const mn = date.getMonth();
    const dn = date.getDate();
    let dayOfYear = dayCount[mn] + dn;
    if (mn > 1 && isLeapYear(date.getFullYear())) {
        dayOfYear++;
    }
    return dayOfYear;
}
function firstWeekOffset(year, dow, doy) {
    const fwd = 7 + dow - doy;
    const fwdlw = (7 + new Date(Date.UTC(year, 0, fwd)).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
function weeksInYear(year, dow, doy) {
    const weekOffset = firstWeekOffset(year, dow, doy);
    const weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
function weekOfYear(mom, dow, doy) {
    const weekOffset = firstWeekOffset(mom.getFullYear(), dow, doy);
    const week = Math.floor((getDayOfYear(mom) - weekOffset - 1) / 7) + 1;
    let resWeek;
    let resYear;
    if (week < 1) {
        resYear = mom.getFullYear() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    }
    else if (week > weeksInYear(mom.getFullYear(), dow, doy)) {
        resWeek = week - weeksInYear(mom.getFullYear(), dow, doy);
        resYear = mom.getFullYear() + 1;
    }
    else {
        resYear = mom.getFullYear();
        resWeek = week;
    }
    return {
        week: resWeek,
        year: resYear
    };
}
function getWeekYear(date) {
    return weekOfYear(date, 0, 6);
}
function getISOWeekYear(date) {
    return weekOfYear(date, 1, 4);
}
function suffix(d) {
    return ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : ((d % 100 - d % 10 !== 10) ? 1 : 0) * d % 10];
}
function pad(val, len) {
    val = String(val);
    len = len || 2;
    while (val.length < len) {
        val = '0' + val;
    }
    return val;
}
function dateFormat(date, format) {
    if (typeof date === 'undefined') {
        date = new Date();
    }
    if (isNaN(date.getTime())) {
        throw TypeError('Invalid date');
    }
    format = format || 'YYYY-MM-DDTHH:mm:ssZ';
    format = expandFormat(format);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();
    const tzOffset = date.getTimezoneOffset();
    const ISOWeekYear = getISOWeekYear(date);
    const weekYear = getWeekYear(date);
    const quarter = Math.floor((month + 2) / 3);
    const DOY = getDayOfYear(date);
    const DOW = date.getDay();
    const absTZ = Math.floor(Math.abs(tzOffset) / 60) * 100 + Math.abs(tzOffset) % 60;
    const flags = {
        M: month,
        Mo: month + suffix(month),
        MM: pad(month),
        MMM: exports.i18n.monthNames[month - 1],
        MMMM: exports.i18n.monthNames[month + 11],
        Q: quarter,
        Qo: quarter + suffix(quarter),
        D: day,
        Do: day + suffix(day),
        DD: pad(day),
        DDD: DOY,
        DDDo: DOY + suffix(DOY),
        DDDD: pad(DOY, 3),
        d: DOW,
        do: DOW + suffix(DOW),
        dd: exports.i18n.dayNames[DOW],
        ddd: exports.i18n.dayNames[DOW + 7],
        dddd: exports.i18n.dayNames[DOW + 14],
        e: DOW,
        E: DOW === 0 ? 7 : DOW,
        w: weekYear.week,
        wo: weekYear.week + suffix(weekYear.week),
        ww: pad(weekYear.week),
        W: ISOWeekYear.week,
        Wo: ISOWeekYear.week + suffix(ISOWeekYear.week),
        WW: pad(ISOWeekYear.week),
        Y: year,
        YY: pad(year % 100),
        YYYY: year,
        gg: pad(weekYear.year % 100),
        gggg: weekYear.year,
        GG: pad(ISOWeekYear.year % 100),
        GGGG: ISOWeekYear.year,
        a: hours < 12 ? 'am' : 'pm',
        A: hours < 12 ? 'AM' : 'PM',
        H: hours,
        HH: pad(hours),
        h: hours % 12 || 12,
        hh: pad(hours % 12 || 12),
        k: hours ? hours : 24,
        kk: pad(hours ? hours : 24),
        m: minutes,
        mm: pad(minutes),
        s: seconds,
        ss: pad(seconds),
        S: pad(milliseconds, 3).slice(0, 1),
        SS: pad(milliseconds, 3).slice(0, 2),
        SSS: pad(milliseconds, 3),
        SSSS: pad(milliseconds * 10, 4),
        Z: (tzOffset > 0 ? '-' : '+') + pad(absTZ, 4).slice(0, 2) + ':' + pad(absTZ, 4).slice(2, 4),
        ZZ: (tzOffset > 0 ? '-' : '+') + pad(absTZ, 4),
        X: Math.floor(date.valueOf() / 1000),
        x: date.valueOf()
    };
    return format.replace(formattingTokens, function (match) {
        if (match in flags) {
            return flags[match];
        }
        return match.replace(/^\[(.*?)\]$/, '$1');
    });
}
//# sourceMappingURL=date-format.js.map